import { Box, Typography, keyframes } from "@mui/material";

const pulse = keyframes`
  0% { opacity: 0.3; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.3; transform: scale(0.95); }
`;

const scan = keyframes`
  0% { transform: translateY(-100%); }
  100% { transform: translateY(300%); }
`;

export const GalacticLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "50vh",
        gap: 3,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 80,
          height: 80,
          border: "2px solid rgba(0, 242, 255, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          animation: `${pulse} 2s infinite ease-in-out`,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            border: "2px solid #00f2ff",
            boxShadow: "0 0 15px #00f2ff",
            transform: "rotate(45deg)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "2px",
            background: "#00f2ff",
            boxShadow: "0 0 10px #00f2ff",
            animation: `${scan} 1.5s infinite linear`,
          }}
        />
      </Box>
      <Typography
        sx={{
          fontFamily: "'Orbitron', sans-serif",
          color: "#00f2ff",
          letterSpacing: "4px",
          fontSize: "0.8rem",
          animation: `${pulse} 2s infinite ease-in-out`,
        }}
      >
        RETRIEVING DATA...
      </Typography>
    </Box>
  );
};
